
export default {
  add: '新增',
  confirm: '确定',
  search: '搜索',
  operate: '操作',
  detail: '详情',
  edit: '编辑',
  delete: '删除',
  save: '保存',
  cancel: '取消',
  deleteMsg: '删除成功!',
  deleteboxContent: '此操作将永久删除该项, 是否继续?',
  tip: '提示',
  error: '错误',
  saveSuccess: '保存成功',
  serialNumber: '序号',
  confirmBlock: "确 认",
  cancelBlock: "取 消",
  searchBlock: "搜 索",
  confirmBlock1: "确 定",
  to: "至",
  submit: "提交",
  upload: "上传",
  success: "成功",
  publish: "发布",
  yse: "是",
  no: "否",
  pleaseSelect: "请选择",
  to: "至",
  startDate: "开始日期",
  endDate: "结束日期",
  searchCondition: "搜索条件",
  failure: "失败",
  count: '个',
  piece: '条',
  currentDate: '当前日期',
  currentWeek: '当前周',
  currentMonth: '当前月',
  currentYear: '当前年',
  goback: '返回',
  network: '请求失败，',
  clickRefresh: '点击刷新',
  noData: '暂无数据',
  loading: '加载中...',
  refresh: '刷新',
};



// WEBPACK FOOTER //
// ./src/locale/lang/zh-CN/common.js